import AxiosCustom from "../../components/common/apiConfigPouyan/index";

export function retray_send_otp_api(payload) {
  const config = {
    url: `/OTP/RetrySendOTP/RetrySendOTP/${payload?.data?.NationalCode}`
  };

  const data = {};


  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
